import { render, staticRenderFns } from "./ImprestCardActions.vue?vue&type=template&id=d8f2bb88"
import script from "./ImprestCardActions.vue?vue&type=script&lang=js"
export * from "./ImprestCardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports